import React, { useEffect, useState } from 'react';
import css from './InputText.module.css'
import classnames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function InputText(props) {
  const {placeholder, defaultValue, type, icon, className, parentValue, isDisabled} = props;

  const [value, setValue] = useState(defaultValue);

  function onChangeValue(e){
    if(typeof props.onC === "function"){
      props.onC(e);
    }
    setValue(e.target.value);
  }

  useEffect(() => {
    if(parentValue){
      setValue(parentValue);

      const tempEvent = {target: {value: parentValue}}
      onChangeValue(tempEvent)
    }
  }, [])

  //setValue('Hello');
  const iconComponent = () => {
    if(icon){
      return (<FontAwesomeIcon className={css.icon} icon={icon}/>);
    }
  }

  return (
    <div className={classnames(css.base, className)}>
      {iconComponent()}
      <input disabled={isDisabled} value={value} onChange={onChangeValue} placeholder={placeholder} className={css.input} type={type}/>
    </div>
  )
}
